<i18n src="./translations"></i18n>

<template>
  <div v-if="hasContent" :class="classes" :data-preload="[$options.name]">
    <div
      v-if="!!priceTexts.exchangePartValue"
      class="priceText qa-PriceInfo__exchangePart"
    >
      {{
        $t('price-texts.exchange_part', {
          '%gross_exchange_part_value%': priceTexts.exchangePartValue,
        })
      }}
    </div>

    <div
      v-if="priceTexts.description"
      class="priceText qa-PriceInfo__description"
    >
      {{ priceTexts.description }}
    </div>

    <div v-if="showBulkyPrice" class="priceText qa-PriceInfo__bulkyPrice">
      {{
        $t('price-texts.bulky_price', {
          '%formattedBulkyPrice%': priceTexts.bulkyPrice,
        })
      }}
    </div>

    <div v-if="showRiskyPrice" class="priceText qa-PriceInfo__bulkyPrice">
      {{
        $t('price-texts.risky_price', {
          '%formattedRiskyPrice%': priceTexts.riskyPrice,
        })
      }}
    </div>
  </div>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';
import { mapGetters } from 'vuex';

export default {
  name: 'PriceTexts',
  mixins: [globalMixin],
  props: {
    priceTexts: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('core', ['isBusinessCustomer', 'getCompanyInformation']),
    isDirectDelivery() {
      return (
        (this.isBusinessCustomer &&
          this.getCompanyInformation?.isDirectDelivery) ||
        false
      );
    },
    showBulkyPrice() {
      const { bulkyPrice } = this.priceTexts || {};
      const hasValidBulkyPrice =
        bulkyPrice && !String(bulkyPrice).includes('0,00');

      return !this.isDirectDelivery && hasValidBulkyPrice;
    },
    showRiskyPrice() {
      return !this.isDirectDelivery && this.priceTexts?.riskyPrice;
    },
    hasContent() {
      return (
        !!this.priceTexts?.exchangePartValue ||
        !!this.priceTexts?.description ||
        this.showBulkyPrice ||
        !!this.showRiskyPrice
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';

.priceTexts {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);

  .priceText {
    color: var(--color-blackout);
    font-size: var(--font-size-S);
    line-height: var(--space-2);

    &:last-child {
      margin-bottom: 0;
    }
  }
}

@media #{$_mediaSDown} {
  .priceTexts {
    &--slim {
      .priceText {
        font-size: 11px;
        line-height: 1.3em;
      }
    }
  }
}

@media #{$_mediaMDown} {
  .priceText {
    margin: 4px 0;
  }
}
</style>
